export default __webpack_public_path__ + "static/media/beginning_1_m.f4064dc2.jpg";